import { BaseInterface } from 'Interfaces'
import { ConfigProvider, message } from 'antd'

const ThemeProvider: React.FC<BaseInterface> = ({ children }) => {
  const props = {}
  const [_, contextHolder] = message.useMessage()

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            colorBgBase: '#0061DF',
            subMenuItemBg: '#0059CD',
            itemSelectedColor: '#FFFFFF',
            itemSelectedBg: '#0059CD',
            itemColor: '#72AFFF'
          }
        }
      }}
    >
      <>
        {contextHolder}
        {children}
      </>
    </ConfigProvider>
  )
}

export default ThemeProvider
